import { getAuth } from "firebase/auth";

export async function useApiContext(apiService, dataHelper) {
  try {
    const userToken = await getAuth().currentUser?.getIdToken();

    apiService.setBaseUrl(await dataHelper.getHerokuDomain());
    apiService.setUserToken(userToken);
    dataHelper.setApiService(apiService);
  } catch (error) {
    console.log(`error`, error);
  }
}
